import request from "@/utils/request1";
import baseURL from "@/utils/baseUrl1";

 const personService = {}
 let base_url = baseURL.person


// 举报提交
personService.reportsub = function (params, otp) {
    return request ({
        url: '/report',
        method: 'post',
        baseURL: base_url,
        data: params,
        headers: {
            'OTP': otp
        }
    })
}
// 获取令牌
personService.getOtp = function () {
    return request ({
        url: '/report/getOtp',
        method: 'get',
        baseURL: base_url
    })
}
// 获取类型
personService.getType = function (parentCode) {
    return request ({
        url: '/report/getType',
        method: 'get',
        params: {
            parentCode: parentCode
        },
        baseURL: base_url
    })
}
// 获取验证码
personService.queryphone = function (phone) {
    return request ({
        url: `/send/code?phone=${phone}`,
        method: 'get',
        baseURL: base_url,
    })
}

personService.updatereport = function (params) {
    return request ({
        url: '/report/update/'+params.id,
        method: 'put',
        baseURL: base_url,
        data: params
    })
}
 export default personService